// The API's resource paths and the group types the app filters on.

// API Endpoints
export const API_ENDPOINTS = {
  WORKSPACES: "/workspaces/",
  GROUPS: "/groups/",
  LINKS: "/links/",
  NOTES: "/notes/",
  THREADS: "/threads/",
  REMINDERS: "/reminders/",
  REFERENCE_GUIDES: "/reference-guides/",
} as const;

// Group Types
export const GROUP_TYPES = {
  LINKS: "links",
  NOTES: "notes",
} as const;
